<template>
  <div class="BuildingAdjustments">
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :layout="layout"
      :disabled="disabled"
      :path="path"
      :viewer="viewer"
    />
  </div>
</template>

<script>
import FieldSet from '@/components/form/FieldSet'

export default {
  name: 'BuildingAdjustments',
  components: { FieldSet },
  props: {
    label: {
      type: String,
      default: 'Uitvoering van (grote) aanpassing/vervanging hoofdverdeelkast',
    },
    values: {
      type: Object,
      default: function() {
        return {}
      },
    },
    path: {
      type: String,
      default: 'BuildingAdjustments',
    },
    columns: {
      type: String,
      default: '1fr 1fr 1fr 1fr 1fr',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Copied from Cafienne
      fields: {
        'FuseBoxAdjustmentRequestDate': {
            // "title": "Datum dat aanpassing hoofdverdeelkast is aangevraagd",
            'title': 'Datum van aanvraag',
            'type': 'string',
            'format': 'date',
        },
        'FuseBoxAdjustmentExpectedFinishDate': {
            // "title": "Verwachte datum dat de aanpassing van de hoofdverdeelkast klaar is",
            'title': 'Verwachte opleveringsdatum',
            'type': 'string',
            'format': 'date',
        },
        'FuseBoxAdjustmentFinishDate': {
            // "title": "Daadwerkelijke datum dat de aanpassing van de hoofdverdeelkast klaar was",
            'title': 'Daadwerkelijke opleveringsdatum',
            'type': 'string',
            'format': 'date',
        },
      },
      layout: [{
        'columns': '1fr 1fr 1fr',
        'fields': ['FuseBoxAdjustmentRequestDate', 'FuseBoxAdjustmentExpectedFinishDate', 'FuseBoxAdjustmentFinishDate'],
      }],
    }
  },
}
</script>
